// frontend/packs/resources-show.js

/* eslint-disable import/first, import/newline-after-import */

import { Application } from 'stimulus';
export const resourceShow = Application.start(); // eslint-disable-line import/prefer-default-export

import 'components/resources/show/resource-show-main/resource-show-main';
import 'components/resources/show/resource-details/resource-details';
import 'components/resources/show/free-attribution-slidedown/free-attribution-slidedown';
import 'components/resources/show/resource-show-sidebar/resource-show-sidebar';
import 'components/resources/show/license-selector-modal/license-selector-modal';
import 'components/resources/show/download-popup/download-popup';
import 'components/resources/show/post-purchase-banner/post-purchase-banner';

import 'components/util/tags-carousel/tags-carousel';
import 'components/resources/show/resource-related/resource-related';
import 'components/resources/show/resource-comments/resource-comments';
import 'components/sstk/resource-show/sponsored-similar/sponsored-similar';
import 'components/resources/grid/grid';

import 'components/license/license-info-modal/license-info-modal';
import 'components/license/license-compare-modal/license-compare-modal';
import 'components/license/license-attribution-modal/license-attribution-modal';
import 'components/global/promos/promo-popup';

import ResourceShowMainController from '../components/resources/show/resource-show-main/resource-show-main-controller';
resourceShow.register('resource-show-main', ResourceShowMainController);

import ResourceDetailsController from '../components/resources/show/resource-details/resource-details-controller';
resourceShow.register('resource-details', ResourceDetailsController);

import ResourceShowSidebarController from '../components/resources/show/resource-show-sidebar/resource-show-sidebar-controller';
resourceShow.register('resource-show-sidebar', ResourceShowSidebarController);

import ResourceCommentsController from '../components/resources/show/resource-comments/resource-comments-controller';
resourceShow.register('resource-comments', ResourceCommentsController);

import DownloadButtonController from '../components/resources/show/download-btn/download-btn-controller';
resourceShow.register('download-btn', DownloadButtonController);

import FreeAttributionSlidedownController from '../components/resources/show/free-attribution-slidedown/free-attribution-slidedown-controller';
resourceShow.register('free-attribution-slidedown', FreeAttributionSlidedownController);

import CopyrightLinkController from '../components/util/copyright-link/copyright-link-controller';
resourceShow.register('copyright-link', CopyrightLinkController);

import LicenseSelectorFreeModalController from '../components/resources/show/license-selector-modal/license-selector-free-modal-controller';
resourceShow.register('license-selector-free-modal', LicenseSelectorFreeModalController);

import LicenseSelectorCreditModalController from '../components/resources/show/license-selector-modal/license-selector-credit-modal-controller';
resourceShow.register('license-selector-credit-modal', LicenseSelectorCreditModalController);

import LicenseCompareModalController from '../components/license/license-compare-modal/license-compare-modal-controller';
resourceShow.register('license-compare-modal', LicenseCompareModalController);

import EzCarouselController from '../components/util/ez-carousel/ez-carousel-controller';
resourceShow.register('ez-carousel', EzCarouselController);

import PostPurchaseBannerController from '../components/resources/show/post-purchase-banner/post-purchase-banner-controller';
resourceShow.register('post-purchase-banner', PostPurchaseBannerController);

import SSTKSponsoredSimilarController from '../components/sstk/resource-show/sponsored-similar/sponsored-similar-controller';
resourceShow.register('sstk-sponsored-similar', SSTKSponsoredSimilarController);

import ResourcesGridController from '../components/resources/grid/grid-controller';
resourceShow.register('resources-grid', ResourcesGridController);

import DownloadPopupController from '../components/resources/show/download-popup/download-popup-controller';
resourceShow.register('download-popup', DownloadPopupController);

import PromoPopupController from '../components/global/promos/promo-popup-controller';
resourceShow.register('promo-popup', PromoPopupController);
